// Hex -> RGB 변환
const hexToRgb = (hex: string) => {
    const parsedHex = hex.replace("#", "");
    const bigint = parseInt(parsedHex, 16);
    return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
    };
};

// RGB -> Hex + Alpha 변환
const rgbToHexWithAlpha = (
    { r, g, b }: { r: number; g: number; b: number },
    opacity: number,
) => {
    const alpha = Math.round(opacity * 255)
        .toString(16)
        .padStart(2, "0");
    return `#${((1 << 24) + (r << 16) + (g << 8) + b)
        .toString(16)
        .slice(1)}${alpha}`;
};

// 500 색상을 10% opacity로 변환
const convertToShade = (hex: string): string => {
    const rgb = hexToRgb(hex);
    const res = rgbToHexWithAlpha(rgb, 0.1); // 10% opacity

    return res;
};

/**
 * @description 헥사코드 색상인지 확인합니다.
 */
const isHexColor = (color: string): boolean =>
    /^#([0-9A-F]{3}|[0-9A-F]{6}|[0-9A-F]{8})$/i.test(color);

export const CalendarHelper = {
    isHexColor,
    convertToShade,
};
